import React from 'react';
import { useTheme } from 'styled-components';

export const CornerExpandSvg = (props) => {
  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "10"} height={height ?? "10"} viewBox="0 0 10 10" fill={color ?? theme?.colour?.secondary ?? "#04333B"} xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 0H6.5C6.2 0 6 0.2 6 0.5C6 0.8 6.2 1 6.5 1H8.3L5.65 3.65C5.45 3.85 5.45 4.15 5.65 4.35C5.85 4.55 6.15 4.55 6.35 4.35L9 1.7V3.5C9 3.8 9.2 4 9.5 4C9.8 4 10 3.8 10 3.5V0.5C10 0.2 9.8 0 9.5 0ZM4.5 5H0.5C0.2 5 0 5.2 0 5.5V9.5C0 9.8 0.2 10 0.5 10H4.5C4.8 10 5 9.8 5 9.5V5.5C5 5.2 4.8 5 4.5 5Z" />
    </svg>
  )
}